import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Piano} from "../../../models/Piano";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
   selector: 'app-notifications',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './notifications.component.html',
   styleUrls: ['./notifications.component.scss']
})

export class NotificationsComponent implements OnInit {
   protected readonly Piano = Piano;

   @Input() severity = Piano.SeverityChoices.INFO | Piano.SeverityChoices.ERROR | Piano.SeverityChoices.WARNING | Piano.SeverityChoices.SUCCESS;
   @Input() message = ''
   @Input() subMessage = ''
   @Input() showCompletaRegistrazione = false
   @Input() showAggiornaPiano = false
   @Input() vendorSlug = ''

   constructor(private router: Router,
               private route: ActivatedRoute,
               ) {}

   ngOnInit(): void {
      console.log(this.vendorSlug)
   }

   clickCompleteRegister() {
      this.router.navigate([`/ng/e/${this.vendorSlug}/register`], {relativeTo:this.route})
   }

   clickGoToAggiornaPiano() {
      this.router.navigate([`/ng/pricing/esercizi/${this.vendorSlug}`], {relativeTo:this.route})
   }

}
